export const setColorByIndex = (index) => {
  if (index === 0) return "cards.gray";
  else if (index % 2 === 0) return "cards.gray";
  else return "white";
};

export const redirect = (ip, version, device_id) => {
  window.location.href = `http://${ip}/${version}/Boleteria/admin/app/ATM.php?device_id=${device_id}`;
};
